import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '../App';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success('Message sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message');
    } finally {
      setSubmitting(false);
    }
  };

  const handleWhatsAppMessage = () => {
    const lines = [
      'Hello Adhva Academy, I would like to get in touch.',
      formData.name && `Name: ${formData.name}`,
      formData.email && `Email: ${formData.email}`,
      formData.phone && `Phone: ${formData.phone}`,
      formData.message && `Message: ${formData.message}`
    ].filter(Boolean);

    window.open(
      `https://wa.me/918867198007?text=${encodeURIComponent(lines.join('\n'))}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div>
      <Navbar />
      
      <div className="page-header">
        <div className="container">
          <h1 data-testid="page-title">Contact Us</h1>
          <p>We're here to help you succeed</p>
        </div>
      </div>

      <section className="py-8 container">
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '3rem' }}>
          <div>
            <h2 style={{ marginBottom: '2rem' }}>Get in Touch</h2>
            <div className="card">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Your Name *</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    data-testid="name-input"
                  />
                </div>

                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    data-testid="email-input"
                  />
                </div>

                <div className="form-group">
                  <label>Phone Number (Optional)</label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    data-testid="phone-input"
                  />
                </div>

                <div className="form-group">
                  <label>Your Message *</label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    rows="6"
                    required
                    data-testid="message-input"
                  />
                </div>

                <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={submitting} data-testid="submit-btn">
                  {submitting ? 'Sending...' : 'Send Message'}
                </button>
                <button
                  type="button"
                  onClick={handleWhatsAppMessage}
                  className="btn-primary"
                  style={{ width: '100%', marginTop: '0.75rem', background: '#25D366' }}
                >
                  Send a WhatsApp Message
                </button>
              </form>
            </div>
          </div>

          <div>
            <h2 style={{ marginBottom: '2rem' }}>Contact Information</h2>
            <div style={{ display: 'grid', gap: '1.5rem' }}>
              <div className="card">
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📞</div>
                <h3 style={{ marginBottom: '0.5rem' }}>Phone</h3>
                <a href="tel:+918867198007" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>+91 88671 98007 / +91 88671 93007</a>
              </div>

              <div className="card">
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📱</div>
                <h3 style={{ marginBottom: '0.5rem' }}>WhatsApp</h3>
                <a href="https://wa.me/918867198007" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>Chat with us</a>
              </div>

              <div className="card">
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📍</div>
                <h3 style={{ marginBottom: '0.5rem' }}>Address</h3>
                <a href="https://share.google/pTMB7aX8YZZOBxWJZ" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>
                  Kuvempunagar, Mysuru
                </a>
              </div>

              <div className="card">
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📧</div>
                <h3 style={{ marginBottom: '0.5rem' }}>Email</h3>
                <a href="mailto:adhvaacademy@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>adhvaacademy@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--secondary)' }}>
        <div className="container text-center">
          <h2 style={{ marginBottom: '2rem' }}>Office Hours</h2>
          <div className="grid grid-3">
            <div className="card">
              <h3 style={{ marginBottom: '0.5rem', color: 'var(--primary)' }}>Monday - Friday</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>9:00 AM - 6:00 PM</p>
            </div>
            <div className="card">
              <h3 style={{ marginBottom: '0.5rem', color: 'var(--primary)' }}>Saturday</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>10:00 AM - 4:00 PM</p>
            </div>
            <div className="card">
              <h3 style={{ marginBottom: '0.5rem', color: 'var(--primary)' }}>Sunday</h3>
              <p style={{ color: 'var(--muted-foreground)' }}>9:00 AM - 1:00 PM</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 container text-center">
        <h2 style={{ marginBottom: '1.5rem' }}>Ready to Start Your Preparation?</h2>
        <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem', fontSize: '1.125rem' }}>
          Enroll now in our comprehensive UPSC preparation programs
        </p>
        <a 
          href="https://forms.gle/5mjmuxov7LaYCHTU6" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn-primary" 
          style={{ fontSize: '1.1rem', padding: '1rem 2.5rem' }}
        >
          Enroll Now →
        </a>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
